module.exports = __webpack_public_path__ + "img/52car.4075643d.png";